import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { GroupPortalDataService } from "../services";
import { MemberType } from "../../shared/enums/data.enums";

@Injectable({
  providedIn: 'root'
})
export class ChaptersGuard implements CanActivate {
  constructor(
    private router: Router,
    private groupPortalDataService: GroupPortalDataService
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let p = this.groupPortalDataService.memberAppData ? this.groupPortalDataService.memberAppData.profile : null;

    if (p && p.IsInternational) {
      this.groupPortalDataService.navigateToRoute("sections");
      return false;
    }
    return true;
  }
}
